<!--
 * @Descripttion: create file
 * @Author: zhangtingjiang
 * @Date: 2021-03-10 14:06:04
-->
<template>
  <div class="player-container">
    <div class="poster">
      <img :src="player.icon" alt="logo">
    </div>
    <div class="content">
      <!-- 2022.8.22日安徽需求，安徽因为要直播选手比赛，下载的过程评委会看到，要求隐藏选手姓名 -->
      <p v-if="false">姓名：{{player.name}}</p>
      <p>题目：{{subjectTitle}}</p>
      <p>地点：{{address}}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    subjectTitle: {
      type: String,
      default: ''
    },
    address: {
      type: String,
      default: ''
    }
  },
  computed: {
    player () {
      const playerInfoFromStorage = JSON.parse(localStorage.getItem('PersonInfo'))
      if (!playerInfoFromStorage) {
        return {}
      }
      const player = playerInfoFromStorage.user
      if (!player) {
        return {}
      }
      return {
        icon: player.host + player.icon,
        name: player.name,
        phone: player.phone,
        gender: player.gender === 'male' ? '男' : '女',
        org: player.union ? player.union.title : ''
      }
    }
  }
}
</script>
<style scoped lang='scss'>
.player-container {
  display: flex;
  align-items: flex-start;
}

.poster {
  width: 120px;
  height: 139px;
  border-radius: 4px;
  background: #dcdfe6;
  border: 1px solid #DCDFE6;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.content {
  margin-left: 26px;
  text-align: left;
  p {
    margin: 0;
    font-size: 16px;
    font-weight: 400;
    color: #4E5A73;
    line-height: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/player-download/index.vue